import { render, staticRenderFns } from "./staffMange.vue?vue&type=template&id=47ddfa38&scoped=true"
import script from "./staffMange.vue?vue&type=script&lang=js"
export * from "./staffMange.vue?vue&type=script&lang=js"
import style0 from "./staffMange.vue?vue&type=style&index=0&id=47ddfa38&prod&lang=less&scoped=true"
import style1 from "./staffMange.vue?vue&type=style&index=1&id=47ddfa38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ddfa38",
  null
  
)

export default component.exports